import { Link } from 'react-router-dom';
import './JobsDirectionCtaSection.css';

function JobsDirectionCtaSection() {
  return (
    <section className="jobs-direction-cta" aria-labelledby="jobs-direction-cta-title">
      <div className="jobs-direction-cta__inner">
        <div className="jobs-direction-cta__copy">
          <p className="jobs-direction-cta__eyebrow">NOT SURE WHICH ROLE FITS YOU?</p>
          <h2 id="jobs-direction-cta-title" className="jobs-direction-cta__title">
            Let&apos;s choose the direction first.
          </h2>
          <p className="jobs-direction-cta__subtitle">
            The Career Authoring cohort helps you pick the role worth aiming for then builds the
            plan to get there, with mentorship the whole way. No pressure, just a clearer map.
          </p>
        </div>

        <div className="jobs-direction-cta__action">
          <Link className="jobs-direction-cta__button" to="/career-authoring-program">
            Explore Career Authoring
          </Link>
        </div>
      </div>
    </section>
  );
}

export default JobsDirectionCtaSection;
